{********************************************************************}
{                                                                    }
{ written by TMS Software                                            }
{            copyright (c) 2022                                      }
{            Email : info@tmssoftware.com                            }
{            Web : https://www.tmssoftware.com                       }
{                                                                    }
{ The source code is given as is. The author is not responsible      }
{ for any possible damage done due to the use of this code.          }
{ The complete source code remains property of the author and may    }
{ not be distributed, published, given or sold in any form as such.  }
{ No parts of the source code can be included in any other component }
{ or application without written authorization of the author.        }
{********************************************************************}

unit WEBLib.TMSFNCChartDatabaseAdapter;

interface

{$I WEBLib.TMSFNCDefines.inc}

{$IFDEF WEBLIB}
{$DEFINE LCLWEBLIB}
{$ENDIF}
{$IFDEF LCLLIB}
{$DEFINE LCLWEBLIB}
{$ENDIF}

uses
  Classes, WEBLib.TMSFNCChart, {%H-}WEBLib.TMSFNCTypes, SysUtils
  {$IFDEF LCLWEBLIB}
  , DB
  {$ENDIF}
  {$IFNDEF LCLWEBLIB}
  , Data.DB
  {$ENDIF}
  ;

const
  MAJ_VER = 1; // Major version nr.
  MIN_VER = 0; // Minor version nr.
  REL_VER = 0; // Release nr.
  BLD_VER = 1; // Build nr.

  // version history
  // v1.0.0.0 : first release
  // v1.0.0.1 : Improved : Loading mechanism

type
  TTMSFNCChartDatabaseAdapterSource = class;

  TTMSFNCChartDatabaseAdapter = class;

  TTMSFNCChartDatabaseAdapterDataLink = class(TDataLink)
  private
    FSource: TTMSFNCChartDatabaseAdapterSource;
  protected
    procedure ActiveChanged; override;
    procedure DataSetChanged; override;
    procedure DataSetScrolled(Distance: Integer); override;
    procedure RecordChanged(Field: TField); override;
    function Adapter: TTMSFNCChartAdapter;
  public
    constructor Create(ASource: TTMSFNCChartDatabaseAdapterSource);
    destructor Destroy; override;
  end;

  TTMSFNCChartDatabaseAdapterSeriesItem = class(TCollectionItem)
  private
    FXValue: string;
    FYvalue: string;
    FYValueVariable: string;
    FYValueSecond: string;
    FXLabel: string;
    FYvalueLow: string;
    FYvalueOpen: string;
    FYvalueMedian: string;
    FYvalueHigh: string;
    FYvalueClose: string;
    procedure SetXLabel(const Value: string);
    procedure SetXValue(const Value: string);
    procedure SetYValue(const Value: string);
    procedure SetYValueSecond(const Value: string);
    procedure SetYValueVariable(const Value: string);
    procedure SetYValueClose(const Value: string);
    procedure SetYValueHigh(const Value: string);
    procedure SetYValueLow(const Value: string);
    procedure SetYValueMedian(const Value: string);
    procedure SetYValueOpen(const Value: string);
  protected
    procedure DoChanged; virtual;
  public
    constructor Create(ACollection: TCollection); override;
    destructor Destroy; override;
    procedure Assign(Source: TPersistent); override;
  published
    property YValue: string read FYvalue write SetYValue;
    property XValue: string read FXValue write SetXValue;
    property XLabel: string read FXLabel write SetXLabel;
    property YValueSecond: string read FYValueSecond write SetYValueSecond;
    property YValueVariable: string read FYValueVariable write SetYValueVariable;
    property YValueHigh: string read FYvalueHigh write SetYValueHigh;
    property YValueLow: string read FYvalueLow write SetYValueLow;
    property YValueOpen: string read FYvalueOpen write SetYValueOpen;
    property YValueClose: string read FYvalueClose write SetYValueClose;
    property YValueMedian: string read FYvalueMedian write SetYValueMedian;
  end;


  TTMSFNCChartDatabaseAdapterSeries = class(TOwnedCollection)
  private
    FSource: TTMSFNCChartDatabaseAdapterSource;
    function GetItem(Index: Integer): TTMSFNCChartDatabaseAdapterSeriesItem;
    procedure SetItem(Index: Integer; const Value: TTMSFNCChartDatabaseAdapterSeriesItem);
  public
    function Source: TTMSFNCChartDatabaseAdapterSource;
    constructor Create(ASource: TTMSFNCChartDatabaseAdapterSource);
    function Add: TTMSFNCChartDatabaseAdapterSeriesItem;
    function Insert(Index: Integer): TTMSFNCChartDatabaseAdapterSeriesItem;
    property Items[Index: Integer]: TTMSFNCChartDatabaseAdapterSeriesItem read GetItem write SetItem; default;
  end;


  TTMSFNCChartDatabaseAdapterSource = class(TPersistent)
  private
    FUpdateCount: Integer;
    FDataLink: TTMSFNCChartDatabaseAdapterDataLink;
    FAdapter: TTMSFNCChartAdapter;
    FSeries: TTMSFNCChartDatabaseAdapterSeries;
    function GetDataSource: TDataSource;
    procedure SetDataSource(const Value: TDataSource);
    procedure SetSeries(const Value: TTMSFNCChartDatabaseAdapterSeries);
  protected
    function CheckDataSet: Boolean;
    procedure BeginUpdate; virtual;
    procedure EndUpdate; virtual;
    function IsUpdating: Boolean; virtual;
    function GetOwner: TPersistent; override;
  public
    constructor Create(AAdapter: TTMSFNCChartAdapter);
    procedure Assign(Source: TPersistent); override;
    destructor Destroy; override;
  published
    property DataSource: TDataSource read GetDataSource write SetDataSource;
    property Series: TTMSFNCChartDatabaseAdapterSeries read FSeries write SetSeries;
  end;

  TTMSFNCChartDatabaseAdapterFieldsToSeriesEvent = procedure(Sender: TObject; AFields: TFields; ASeries: TTMSFNCChartSerie) of object;
  TTMSFNCChartDatabaseAdapterFieldsToPointEvent = procedure(Sender: TObject; AFields: TFields; ASeries: TTMSFNCChartSerie; APoint: TTMSFNCChartPoint) of object;
  TTMSFNCChartDatabaseAdapterSetFieldValueTypeEvent = procedure(Sender: TObject; AFieldName: string; AField: TField; var AValueType: TTMSFNCChartPointValueType) of object;
  TTMSFNCChartDatabaseAdapterSetFieldValueIndexEvent = procedure(Sender: TObject; ASeries: TTMSFNCChartDatabaseAdapterSeries; var AIndex: Integer; var AUseForAllSeries: Boolean) of object;

  {$IFNDEF LCLLIB}
  [ComponentPlatformsAttribute(TMSPlatformsWeb)]
  {$ENDIF}
  TTMSFNCChartDatabaseAdapter = class(TTMSFNCChartAdapter)
  private
    FStartIdx: Integer;
    FSource: TTMSFNCChartDatabaseAdapterSource;
    FSkipFirstColumn: Boolean;
    FOnFieldsToSeries: TTMSFNCChartDatabaseAdapterFieldsToSeriesEvent;
    FOnFieldsToPoint: TTMSFNCChartDatabaseAdapterFieldsToPointEvent;
    FOnSetFieldValueType: TTMSFNCChartDatabaseAdapterSetFieldValueTypeEvent;
    FOnSetFieldValueIndex: TTMSFNCChartDatabaseAdapterSetFieldValueIndexEvent;
    procedure SetSkipFirstColumn(const Value: Boolean);
    procedure SetSource(const Value: TTMSFNCChartDatabaseAdapterSource);
  protected
    procedure RegisterRuntimeClasses; override;
    procedure Notification(AComponent: TComponent; AOperation: TOperation); override;
    procedure DoFieldsToSeries(AFields: TFields; ASeries: TTMSFNCChartSerie); virtual;
    procedure DoFieldsToPoint(AFields: TFields; ASeries: TTMSFNCChartSerie; APoint: TTMSFNCChartPoint); virtual;
    function GetVersion: string; override;
    procedure ParseSeries(ADataSet: TDataSet);
    procedure AutoCreate(ADataSet: TDataSet);
    procedure DoSetFieldValueType(AFieldName: string; AField: TField; var AValueType: TTMSFNCChartPointValueType); virtual;
    procedure DoSetFieldValueIndex(ASeries: TTMSFNCChartDatabaseAdapterSeries; var AIndex: Integer; var AUseForAllSeries: Boolean); virtual;
    procedure InternalBindSeries(YValueColumnsArray: TTMSFNCChartLabelsArray; XValueColumn: string = ''; XLabelColumn: string = ''; YValueSecColumnsArray: TTMSFNCChartLabelsArray = nil; YValueVarColumnsArray: TTMSFNCChartLabelsArray = nil; YValueLowColumn: string = ''; YValueOpenColumn: string = ''; YValueCloseColumn: string = ''; YValueMedianColumn: string = ''); overload; virtual;
  public
    procedure GetItems; override;
    constructor Create(AOwner: TComponent); override;
    procedure Assign(Source: TPersistent); override;
    destructor Destroy; override;
    procedure BindSeries(YValueColumnsArray: TTMSFNCChartLabelsArray; XValueColumn: string = ''; XLabelColumn: string = ''); overload; virtual;
    procedure BindSeriesEx(YValueColumnsArray: TTMSFNCChartLabelsArray; XValueColumn: string = ''; XLabelColumn: string = ''; YValueSecColumnsArray: TTMSFNCChartLabelsArray = nil; YValueVarColumnsArray: TTMSFNCChartLabelsArray = nil); overload; virtual;
    procedure BindSeriesMultiPoint(YValueHighColumn: string; YValueLowColumn: string; YValueOpenColumn: string; YValueCloseColumn: string; YValueMedianColumn: string = ''; XValueColumn: string = ''; XLabelColumn: string = ''); overload; virtual;
  published
    property Version: string read GetVersion;
    property Source: TTMSFNCChartDatabaseAdapterSource read FSource write SetSource;
    property SkipFirstColumn: Boolean read FSkipFirstColumn write SetSkipFirstColumn default True;
    property OnFieldsToSeries: TTMSFNCChartDatabaseAdapterFieldsToSeriesEvent read FOnFieldsToSeries write FOnFieldsToSeries;
    property OnFieldsToPoint: TTMSFNCChartDatabaseAdapterFieldsToPointEvent read FOnFieldsToPoint write FOnFieldsToPoint;
    property OnSetFieldValueType: TTMSFNCChartDatabaseAdapterSetFieldValueTypeEvent read FOnSetFieldValueType write FOnSetFieldValueType;
    property OnSetFieldValueIndex: TTMSFNCChartDatabaseAdapterSetFieldValueIndexEvent read FOnSetFieldValueIndex write FOnSetFieldValueIndex;
  end;

implementation

uses
  WEBLib.TMSFNCUtils, WEBLib.Dialogs;

{$R TMSFNCChartDatabaseAdapter.res}

procedure TTMSFNCChartDatabaseAdapter.Assign(Source: TPersistent);
begin
  if Source is TTMSFNCChartDatabaseAdapter then
    FSource.Assign((Source as TTMSFNCChartDatabaseAdapter).Source);
end;

procedure TTMSFNCChartDatabaseAdapter.AutoCreate(ADataSet: TDataSet);
var
  I, J, idx: Integer;
  fValue: TField;
  sl: TStringList;
  fn, XValField, XLabField: string;
  vt, vto: TTMSFNCChartPointValueType;
  AllSeries: boolean;
  d: Double;
begin
  sl := TStringList.Create;
  try
    ADataSet.GetFieldNames(sl);
    for I := 0 to sl.Count - 1 do
    begin
      fn := sl[I];

      fValue := ADataSet.FieldByName(fn);

      if (FSkipFirstColumn) and (fValue.Index = 0) then
        vto := cvtNone
      else if fValue.DataType in [ftFloat, ftInteger] then
        vto := cvtYValue
      else if fValue.DataType = ftString then
      begin
        d := -123456789;
        TTMSFNCUtils.TryStrToFloatDot(fValue.AsString, d);
        if d <> -123456789 then
          vto := cvtYValue
        else if XLabField = '' then
          vto := cvtXLabel
        else
          vto := cvtNone;
      end
      else
        vto := cvtNone;

      if Source.Series.Count = 0 then
        Source.Series.Add;

      AllSeries := False;
      vt := vto;
      DoSetFieldValueType(fn, fValue, vt);

      idx := -1;

      if vt in [cvtYValue, cvtYValueHigh] then
      begin
        for J := 0 to Source.Series.Count - 1 do
        begin
          if (Source.Series[J].YValue = '') and (Source.Series[J].YValueHigh = '') then
          begin
            idx := J;
            Break;
          end;
        end;
        if idx < 0 then
        begin
          idx := Source.Series.Add.Index;

          if XValField <> '' then
            Source.Series[idx].XValue := XValField;
          if XLabField <> '' then
            Source.Series[idx].XLabel := XLabField;
        end;
      end
      else
        idx := 0;

      DoSetFieldValueIndex(Source.Series, idx, AllSeries);

      if vt = cvtXValue then
        XValField := fn;
      if vt = cvtXLabel then
        XLabField := fn;

      if (vt in [cvtXValue, cvtXLabel]) and AllSeries then
      begin
        for J := 0 to Source.Series.Count - 1 do
        begin
          if vt = cvtXValue then
            Source.Series[J].XValue := XValField;
          if vt = cvtXLabel then
            Source.Series[J].XLabel := XLabField;
        end;
      end
      else if (idx >= 0) and (idx < Source.Series.Count)  then
      begin
        case vt of
          cvtYValue: Source.Series[idx].YValue := fn;
          cvtXValue: Source.Series[idx].XValue := fn;
          cvtXLabel:
          begin
            if (vto <> vt) or (Source.Series[idx].XLabel = '') then
              Source.Series[idx].XLabel := fn;
          end;
          cvtYValueSecond: Source.Series[idx].YValueSecond := fn;
          cvtYValueVariable: Source.Series[idx].YValueVariable := fn;
          cvtYValueHigh: Source.Series[idx].YValueHigh := fn;
          cvtYValueLow: Source.Series[idx].YValueLow := fn;
          cvtYValueOpen: Source.Series[idx].YValueOpen := fn;
          cvtYValueClose: Source.Series[idx].YValueClose := fn;
          cvtYValueMedian: Source.Series[idx].YValueMedian := fn;
        end;
      end;
    end;

  finally
    sl.Free;
  end;
end;

procedure TTMSFNCChartDatabaseAdapter.BindSeries(YValueColumnsArray: TTMSFNCChartLabelsArray; XValueColumn, XLabelColumn: string);
begin
  BindSeriesEX(YValueColumnsArray, XValueColumn, XLabelColumn);
end;

procedure TTMSFNCChartDatabaseAdapter.BindSeriesEx(YValueColumnsArray: TTMSFNCChartLabelsArray; XValueColumn, XLabelColumn: string; YValueSecColumnsArray,
  YValueVarColumnsArray: TTMSFNCChartLabelsArray);
begin
  InternalBindSeries(YValueColumnsArray, XValueColumn, XLabelColumn, YValueSecColumnsArray, YValueVarColumnsArray);
end;

procedure TTMSFNCChartDatabaseAdapter.BindSeriesMultiPoint(YValueHighColumn, YValueLowColumn, YValueOpenColumn, YValueCloseColumn, YValueMedianColumn,
  XValueColumn, XLabelColumn: string);
var
  ayval, aysec, ayvar: TTMSFNCChartLabelsArray;
begin
  SetLength(ayval, 1);
  ayval[0] := YValueHighColumn;
  SetLength(aysec, 0);
  SetLength(ayvar, 0);
  InternalBindSeries(ayval, XValueColumn, XLabelColumn, aysec, ayvar, YValueLowColumn, YValueOpenColumn, YValueCloseColumn, YValueMedianColumn);
end;

constructor TTMSFNCChartDatabaseAdapter.Create(AOwner: TComponent);
begin
  inherited;
  FSource := TTMSFNCChartDatabaseAdapterSource.Create(Self);
  FSkipFirstColumn := True;
end;

destructor TTMSFNCChartDatabaseAdapter.Destroy;
begin
  FSource.Free;
  inherited;
end;

procedure TTMSFNCChartDatabaseAdapter.DoFieldsToPoint(AFields: TFields;
  ASeries: TTMSFNCChartSerie; APoint: TTMSFNCChartPoint);
begin
  if Assigned(OnFieldsToPoint) then
    OnFieldsToPoint(Self, AFields, ASeries, APoint);
end;

procedure TTMSFNCChartDatabaseAdapter.DoFieldsToSeries(AFields: TFields;
  ASeries: TTMSFNCChartSerie);
begin
  if Assigned(OnFieldsToSeries) then
    OnFieldsToSeries(Self, AFields, ASeries);
end;

procedure TTMSFNCChartDatabaseAdapter.DoSetFieldValueIndex(ASeries: TTMSFNCChartDatabaseAdapterSeries; var AIndex: Integer; var AUseForAllSeries: Boolean);
begin
  if Assigned(OnSetFieldValueIndex) then
    OnSetFieldValueIndex(Self, ASeries, AIndex, AUseForAllSeries);
end;

procedure TTMSFNCChartDatabaseAdapter.DoSetFieldValueType(AFieldName: string; AField: TField; var AValueType: TTMSFNCChartPointValueType);
begin
  if Assigned(FOnSetFieldValueType) then
    OnSetFieldValueType(Self, AFieldName, AField, AValueType);
end;

procedure TTMSFNCChartDatabaseAdapter.GetItems;
var
  ds: TDataSet;
  b: TBookmark;
  I: Integer;
  s: TTMSFNCChartSerie;
begin
  if not Assigned(Chart) then
    Exit;

  if not Assigned(Source) then
    Exit;

  if not Source.CheckDataSet then
    Exit;

  if Source.IsUpdating then
    Exit;

  Source.BeginUpdate;
  try
    ds := Source.DataSource.DataSet;
    if Assigned(ds) then
    begin
      ds.DisableControls;
      b := ds.GetBookmark;
      ds.First;

      try
        Chart.BeginUpdate;

        if Chart.DefaultLoadOptions.ClearSeries then
          Chart.Series.Clear;

        FStartIdx := Chart.Series.Count;

        if AutoCreateSeries then
        begin
          Source.Series.Clear;
          AutoCreate(ds);
        end;

        for I := 0 to Source.Series.Count - 1 do
        begin
          if (Source.Series[I].YValue <> '') or (Source.Series[I].YValueHigh <> '') then
          begin
            s := Chart.Series.Add;
            s.XValues.MajorUnitFormatType := Chart.DefaultLoadOptions.XValuesFormatType;
            s.XValues.MajorUnitFormat := Chart.DefaultLoadOptions.XValuesFormatString;
            s.YValues.MajorUnitFormatType := Chart.DefaultLoadOptions.YValuesFormatType;
            s.YValues.MajorUnitFormat := Chart.DefaultLoadOptions.YValuesFormatString;
            s.AutoXRange := Chart.DefaultLoadOptions.XRange;
            s.AutoYRange := Chart.DefaultLoadOptions.YRange;
            s.MaxYOffsetPercentage := Chart.DefaultLoadOptions.MaxYOffsetPercentage;
            s.LegendText := '';

            if (FStartIdx + I) > 0 then
            begin
              s.XValues.Positions := [];
              s.YValues.Positions := [];
            end
            else
            begin
              s.XGrid.Visible := Chart.DefaultLoadOptions.XGrid;
              s.YGrid.Visible := Chart.DefaultLoadOptions.YGrid;
            end;

            if (Source.Series[I].XLabel = '') then
              s.XValues.AutoUnits := True;
          end;
        end;

        while not ds.Eof do
        begin
          ParseSeries(ds);
          ds.Next;
        end;

        for I := 0 to Chart.Series.Count - 1 do
        begin
          DoFieldsToSeries(ds.Fields, Chart.Series[I]);
        end;

        Chart.EndUpdate;

      finally
        if ds.BookmarkValid(b) then
          ds.GotoBookmark(b);

        ds.EnableControls;
        ds.FreeBookmark(b);
      end;
    end;
  finally
    Source.EndUpdate;
  end;
end;

function TTMSFNCChartDatabaseAdapter.GetVersion: string;
begin
  Result := GetVersionNumber(MAJ_VER, MIN_VER, REL_VER, BLD_VER);
end;

procedure TTMSFNCChartDatabaseAdapter.InternalBindSeries(YValueColumnsArray: TTMSFNCChartLabelsArray; XValueColumn, XLabelColumn: string; YValueSecColumnsArray,
  YValueVarColumnsArray: TTMSFNCChartLabelsArray; YValueLowColumn, YValueOpenColumn, YValueCloseColumn, YValueMedianColumn: string);
var
  I: Integer;
  s: TTMSFNCChartDatabaseAdapterSeriesItem;
begin
  if Assigned(FSource) then
  begin
    AutoCreateSeries := False;

    for I := 0 to Length(YValueColumnsArray) - 1 do
    begin
      s := FSource.Series.Add;

      s.FYValue := YValueColumnsArray[I];

      if XValueColumn <> '' then
        s.FXValue := XValueColumn;

      if XLabelColumn <> '' then
        s.FXLabel := XLabelColumn;

      if i < Length(YValueSecColumnsArray) then
        s.FYValueSecond := YValueSecColumnsArray[I];

      if i < Length(YValueVarColumnsArray) then
        s.FYValueVariable := YValueVarColumnsArray[I];

      if YValueLowColumn <> '' then
        s.FYvalueLow := YValueLowColumn;

      if YValueOpenColumn <> '' then
        s.FYvalueOpen := YValueOpenColumn;

      if YValueCloseColumn <> '' then
        s.FYvalueClose := YValueCloseColumn;

      if YValueMedianColumn <> '' then
        s.FYvalueMedian := YValueMedianColumn;
    end;

    if Active then
      LoadItems;
  end;
end;

procedure TTMSFNCChartDatabaseAdapter.Notification(AComponent: TComponent; AOperation: TOperation);
begin
  inherited;
  if (AOperation = opRemove) and Assigned(FSource) and (AComponent = FSource.DataSource) then
  begin
    FSource.DataSource := nil;
  end;
end;

procedure TTMSFNCChartDatabaseAdapter.ParseSeries(ADataSet: TDataSet);
var
  I: Integer;
  s: TTMSFNCChartDatabaseAdapterSeriesItem;
  p: TTMSFNCChartPoint;
  fValue: TField;
  seriesname: string;
begin
  for I := 0 to Source.Series.Count - 1 do
  begin
    s := Source.Series[I];

    if (s.FYvalue <> '') or (s.FYvalueHigh <> '') then
    begin
      if (s.FYvalue <> '') then
      begin
        fValue := ADataSet.FieldByName(s.YValue);
        seriesname := s.YValue;
      end
      else
      begin
        fValue := ADataSet.FieldByName(s.YValueHigh);
        seriesname := s.YValueHigh;
      end;

      if Chart.Series[FStartIdx + I].LegendText = '' then
        Chart.Series[FStartIdx + I].LegendText := seriesname;

      p := Chart.Series[FStartIdx + I].AddPoint(fValue.AsFloat);
    end
    else
      p := Chart.Series[FStartIdx + I].AddPoint(0);

    if s.FXValue <> '' then
    begin
      fValue := ADataSet.FieldByName(s.XValue);
      p.XValue := fValue.AsFloat;
    end;

    if s.FXLabel <> '' then
    begin
      fValue := ADataSet.FieldByName(s.FXLabel);
      p.XValueText := fValue.AsString;
    end;

    if s.FYValueSecond <> '' then
    begin
      fValue := ADataSet.FieldByName(s.YValueSecond);
      p.YValueSecond := fValue.AsFloat;
    end;

    if s.FYValueVariable <> '' then
    begin
      fValue := ADataSet.FieldByName(s.YValueVariable);
      p.YValueVariable := fValue.AsFloat;
    end;

    if s.FYvalueLow <> '' then
    begin
      fValue := ADataSet.FieldByName(s.YValueLow);
      p.YValueLow := fValue.AsFloat;
    end;

    if s.FYvalueOpen <> '' then
    begin
      fValue := ADataSet.FieldByName(s.YvalueOpen);
      p.YvalueOpen := fValue.AsFloat;
    end;

    if s.FYvalueClose <> '' then
    begin
      fValue := ADataSet.FieldByName(s.YvalueClose);
      p.YvalueClose := fValue.AsFloat;
    end;

    if s.FYvalueMedian <> '' then
    begin
      fValue := ADataSet.FieldByName(s.YvalueMedian);
      p.YvalueMedian := fValue.AsFloat;
    end;

    DoFieldsToPoint(ADataSet.Fields, Chart.Series[FStartIdx + I], p);
  end;
end;

procedure TTMSFNCChartDatabaseAdapter.SetSkipFirstColumn(const Value: Boolean);
begin
  if FSkipFirstColumn <> Value then
  begin
    FSkipFirstColumn := Value;

    if Active then
    begin
      LoadItems;
    end;
  end;
end;

procedure TTMSFNCChartDatabaseAdapter.SetSource(
  const Value: TTMSFNCChartDatabaseAdapterSource);
begin
  FSource.Assign(Value);
end;

procedure TTMSFNCChartDatabaseAdapter.RegisterRuntimeClasses;
begin
  inherited;
  RegisterClass(TTMSFNCChartDatabaseAdapter);
end;

{ TTMSFNCChartDatabaseAdapterDataLink }

procedure TTMSFNCChartDatabaseAdapterDataLink.ActiveChanged;
var
  a: TTMSFNCChartAdapter;
begin
  inherited;
  a := Adapter;
  if Assigned(a) then
    a.LoadItems;
end;

function TTMSFNCChartDatabaseAdapterDataLink.Adapter: TTMSFNCChartAdapter;
begin
  Result := nil;
  if Assigned(FSource) then
    Result := FSource.FAdapter;
end;

constructor TTMSFNCChartDatabaseAdapterDataLink.Create(ASource: TTMSFNCChartDatabaseAdapterSource);
begin
  FSource := ASource;
end;

procedure TTMSFNCChartDatabaseAdapterDataLink.DataSetChanged;
var
  a: TTMSFNCChartAdapter;
begin
  inherited;
  a := Adapter;
  if Assigned(a) then
    a.LoadItems;
end;

procedure TTMSFNCChartDatabaseAdapterDataLink.DataSetScrolled(Distance: Integer);
var
  a: TTMSFNCChartAdapter;
begin
  inherited;
  a := Adapter;
  if Assigned(a) then
    a.LoadItems;
end;

destructor TTMSFNCChartDatabaseAdapterDataLink.Destroy;
begin

  inherited;
end;

procedure TTMSFNCChartDatabaseAdapterDataLink.RecordChanged(Field: TField);
var
  a: TTMSFNCChartAdapter;
begin
  inherited;
  a := Adapter;
  if Assigned(a) then
    a.LoadItems;
end;

{ TTMSFNCChartDatabaseAdapterSource }

procedure TTMSFNCChartDatabaseAdapterSource.Assign(Source: TPersistent);
begin
  if Source is TTMSFNCChartDatabaseAdapterSource then
  begin
    DataSource := (Source as TTMSFNCChartDatabaseAdapterSource).DataSource;
  end;
end;

procedure TTMSFNCChartDatabaseAdapterSource.BeginUpdate;
begin
  Inc(FUpdateCount);
end;

function TTMSFNCChartDatabaseAdapterSource.CheckDataSet: Boolean;
begin
  Result := False;

  if ((Series.Count > 0) and (Series[0].YValue <> '')) or (Assigned(FAdapter) and FAdapter.AutoCreateSeries) then
  begin
    if Assigned(DataSource) and Assigned(DataSource.DataSet) then
      Result := DataSource.DataSet.Active;
  end
  else
    raise Exception.Create('No Series added or AutoCreateSeries is not set in TTMSFNCChartDatabaseAdapter source.');
end;

constructor TTMSFNCChartDatabaseAdapterSource.Create(AAdapter: TTMSFNCChartAdapter);
begin
  FUpdateCount := 0;
  FAdapter := AAdapter;
  FSeries := TTMSFNCChartDatabaseAdapterSeries.Create(Self);
  FDataLink := TTMSFNCChartDatabaseAdapterDataLink.Create(Self);
end;

destructor TTMSFNCChartDatabaseAdapterSource.Destroy;
begin
  FDataLink.Free;
  FSeries.Free;
  inherited;
end;

procedure TTMSFNCChartDatabaseAdapterSource.EndUpdate;
begin
  Dec(FUpdateCount);
end;

function TTMSFNCChartDatabaseAdapterSource.GetDataSource: TDataSource;
begin
  Result := nil;
  if Assigned(FDataLink) then
      Result := FDataLink.DataSource;
end;

function TTMSFNCChartDatabaseAdapterSource.GetOwner: TPersistent;
begin
  Result := FAdapter;
end;

function TTMSFNCChartDatabaseAdapterSource.IsUpdating: Boolean;
begin
  Result := FUpdateCount > 0;
end;

procedure TTMSFNCChartDatabaseAdapterSource.SetDataSource(const Value: TDataSource);
begin
  if Assigned(FDataLink) then
  begin
    if FDataLink.DataSource <> Value then
      FDataLink.DataSource := Value;
  end;
end;

procedure TTMSFNCChartDatabaseAdapterSource.SetSeries(const Value: TTMSFNCChartDatabaseAdapterSeries);
begin
  FSeries.Assign(Value);
end;

{ TTMSFNCChartDatabaseAdapterSeries }

function TTMSFNCChartDatabaseAdapterSeries.Add: TTMSFNCChartDatabaseAdapterSeriesItem;
begin
  Result := TTMSFNCChartDatabaseAdapterSeriesItem(inherited Add);
end;

constructor TTMSFNCChartDatabaseAdapterSeries.Create(ASource: TTMSFNCChartDatabaseAdapterSource);
begin
  inherited Create(ASource, TTMSFNCChartDatabaseAdapterSeriesItem);
  FSource := ASource
end;

function TTMSFNCChartDatabaseAdapterSeries.GetItem(Index: Integer): TTMSFNCChartDatabaseAdapterSeriesItem;
begin
  Result := TTMSFNCChartDatabaseAdapterSeriesItem(inherited Items[Index]);
end;

function TTMSFNCChartDatabaseAdapterSeries.Insert(Index: Integer): TTMSFNCChartDatabaseAdapterSeriesItem;
begin
  Result := TTMSFNCChartDatabaseAdapterSeriesItem(inherited Insert(Index));
end;

procedure TTMSFNCChartDatabaseAdapterSeries.SetItem(Index: Integer; const Value: TTMSFNCChartDatabaseAdapterSeriesItem);
begin
  inherited Items[Index] := Value;
end;

function TTMSFNCChartDatabaseAdapterSeries.Source: TTMSFNCChartDatabaseAdapterSource;
begin
  Result := FSource;
end;

{ TTMSFNCChartDatabaseAdapterSeriesItem }

procedure TTMSFNCChartDatabaseAdapterSeriesItem.Assign(Source: TPersistent);
begin
  if Source is TTMSFNCChartDatabaseAdapterSeriesItem then
  begin
    FYValue := (Source as TTMSFNCChartDatabaseAdapterSeriesItem).YValue;
    FYValueSecond := (Source as TTMSFNCChartDatabaseAdapterSeriesItem).YValueSecond;
    FYValueVariable := (Source as TTMSFNCChartDatabaseAdapterSeriesItem).YValueVariable;
    FXValue := (Source as TTMSFNCChartDatabaseAdapterSeriesItem).XValue;
    FXLabel := (Source as TTMSFNCChartDatabaseAdapterSeriesItem).XLabel;
    FYValueHigh := (Source as TTMSFNCChartDatabaseAdapterSeriesItem).YValueHigh;
    FYValueLow := (Source as TTMSFNCChartDatabaseAdapterSeriesItem).YValueLow;
    FYValueOpen := (Source as TTMSFNCChartDatabaseAdapterSeriesItem).YValueOpen;
    FYValueClose := (Source as TTMSFNCChartDatabaseAdapterSeriesItem).YValueClose;
    FYValueMedian := (Source as TTMSFNCChartDatabaseAdapterSeriesItem).YValueMedian;

    DoChanged;
  end
  else
    inherited;
end;

constructor TTMSFNCChartDatabaseAdapterSeriesItem.Create(ACollection: TCollection);
begin
  inherited;
end;

destructor TTMSFNCChartDatabaseAdapterSeriesItem.Destroy;
begin

  inherited;
end;

procedure TTMSFNCChartDatabaseAdapterSeriesItem.DoChanged;
var
  s: TTMSFNCChartDatabaseAdapterSource;
begin
  if Assigned(Collection ) and (Collection is TTMSFNCChartDatabaseAdapterSeries) then
  begin
    s := (Collection as TTMSFNCChartDatabaseAdapterSeries).Source;
    if Assigned(s) and not s.FAdapter.AutoCreateSeries then
      s.FAdapter.LoadItems;
  end;
end;

procedure TTMSFNCChartDatabaseAdapterSeriesItem.SetXLabel(const Value: string);
begin
  if FXLabel <> Value then
  begin
    FXLabel := Value;
    DoChanged;
  end;
end;

procedure TTMSFNCChartDatabaseAdapterSeriesItem.SetXValue(const Value: string);
begin
  if FXValue <> Value then
  begin
    FXValue := Value;
    DoChanged;
  end;
end;

procedure TTMSFNCChartDatabaseAdapterSeriesItem.SetYValue(const Value: string);
begin
  if FYValue <> Value then
  begin
    FYValue := Value;
    DoChanged;
  end;
end;

procedure TTMSFNCChartDatabaseAdapterSeriesItem.SetYValueClose(const Value: string);
begin
  FYvalueClose := Value;
  DoChanged;
end;

procedure TTMSFNCChartDatabaseAdapterSeriesItem.SetYValueHigh(const Value: string);
begin
  FYvalueHigh := Value;
  DoChanged;
end;

procedure TTMSFNCChartDatabaseAdapterSeriesItem.SetYValueLow(const Value: string);
begin
  FYvalueLow := Value;
  DoChanged;
end;

procedure TTMSFNCChartDatabaseAdapterSeriesItem.SetYValueMedian(const Value: string);
begin
  FYvalueMedian := Value;
  DoChanged;
end;

procedure TTMSFNCChartDatabaseAdapterSeriesItem.SetYValueOpen(const Value: string);
begin
  FYvalueOpen := Value;
  DoChanged;
end;

procedure TTMSFNCChartDatabaseAdapterSeriesItem.SetYValueSecond(const Value: string);
begin
  if FYValueSecond <> Value then
  begin
    FYValueSecond := Value;
    DoChanged;
  end;
end;

procedure TTMSFNCChartDatabaseAdapterSeriesItem.SetYValueVariable(const Value: string);
begin
  if FYValueVariable <> Value then
  begin
    FYValueVariable := Value;
    DoChanged;
  end;
end;


end.
